(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["Banner"]) return;
  try {
    
$(document).one("shopify:section:select",'#shopify-section-Banner',function(e){

var myElement = $('#shopify-section-Banner');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}   

$(document).one("shopify:section:deselect",'#shopify-section-Banner',function(e){
$(document).one("shopify:section:select",'#shopify-section-Banner',function(e){

var myElement = $('#shopify-section-Banner');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}  
}); 
});  
});  


$(document).on("shopify:section:select", '#shopify-section-Banner', function(e){
bannerswiper();
$('body').addClass('editing editbanner');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editbanner');
})
});     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["External-Add-To-Cart"]) return;
  try {
    

$(document).one("shopify:section:select",'#shopify-section-External-Add-To-Cart',function(e){
  
  var body = $(this).closest('body');

  if(!body.hasClass('product')) {
     body.addClass('product product2');
  }


  $(document).one("shopify:section:deselect",'#shopify-section-External-Add-To-Cart',function(e){

    if(body.hasClass('product2')) {
     body.removeClass('product product2');
    }

    $(document).one("shopify:section:select",'#shopify-section-External-Add-To-Cart',function(e){
  var body = $(this).closest('body');

  if(!body.hasClass('product')) {
     body.addClass('product product2');
  }
    }); 
  });                           
});            

 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Footer"]) return;
  try {
    
$(document).one("shopify:section:select",'#shopify-section-Footer',function(e){

var myElement = $('#shopify-section-Footer');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}   
$(document).one("shopify:section:deselect",'#shopify-section-Footer',function(e){
$(document).one("shopify:section:select",'#shopify-section-Footer',function(e){

var myElement = $('#shopify-section-Footer');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}   
}); 
});    
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Header-Notification"]) return;
  try {
    
 $(document).on("shopify:section:select",'#shopify-section-Header-Notification',function(e){
 $('body').addClass('editing editnotification').trigger( "updatelayout" );
     $(document).on("shopify:section:deselect",'#shopify-section-Header-Notification',function(e){
        $('body').removeClass('editnotification').trigger( "updatelayout" );
     });   
});     
console.log('test10');       

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Homepage"]) return;
  try {
    
 $(document).one("shopify:section:select",'#shopify-section-Homepage',function(e){

var myElement = $('#shopify-section-Homepage');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}   

 $(document).one("shopify:section:deselect",'#shopify-section-Homepage',function(e){
 $(document).one("shopify:section:select",'#shopify-section-Homepage',function(e){

var myElement = $('#shopify-section-Homepage');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}   
}); 
                           
 });  

$(document).on("shopify:section:load",'#shopify-section-Homepage',function(e){
 rl2();
});
function rl2() {
  if($(window).width() < 600 ) {
   $('[data-rellax]').attr('data-rellax-percentage','0.08');
   var rellax = new Rellax('[data-rellax]', {
    wrapper: '#index',
    round: true,
    vertical: true,
    horizontal: false
  });   
  }else{
    var rellax = new Rellax('[data-rellax]', {

    wrapper: '#swiper_Frame',
    round: true,
    vertical: true,
    horizontal: false
  });
  } 
} 

});   
var p = 1;
function blow() {
   bitchout();
    }

    (function yaya22() {
        if (window.shop) {
            blow();
        } else {
          if(p < 30) {
            window.setTimeout(yaya22, 50);
            p++;
          }else{
           blow();
          }
        }
    })();  


function bitchout() {
if(typeof window.shop !== "undefined" && window.shop == window.password) {
}else{
   function bitch() {
  var o = 0;
 $('.stories').remove();
}
bitch(); 
 }
}                     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Loader"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Loader',function(e){
 $('body').addClass('editing editloader');
 console.log('added');
     $(document).on("shopify:section:deselect",'#shopify-section-Loader',function(e){
        $('body').removeClass('editloader');
     });   
});   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Mobile-Menu"]) return;
  try {
    

 $(document).on("shopify:section:select",'#shopify-section-Mobile-Menu',function(e){
 paneledit();
 $('body').addClass('editing editpanel');

     $(document).on("shopify:section:deselect",'#shopify-section-Mobile-Menu',function(e){
        $('body').removeClass('editpanel');
        paneledit();
     });   
}); 

function paneledit() {
    $("#shopify-section-Mobile-Menu").panel({
      close: function(event, ui) {
        $('#swiper_Frame').removeClass('popup-open');
       stopBodyScrolling(false); 
      },
      open: function(event,ui) {
             var vpH = window.innerHeight;  
      $('#swiper_Frame').addClass('popup-open');
document.documentElement.style.height = vpH.toString() + "px";
$('#swiper_Frame')[0].style.height = vpH.toString() + "px";
stopBodyScrolling(true); 
      }
      
    });
}                

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Popup"]) return;
  try {
    
 $(document).on("shopify:section:select",'#shopify-section-Popup',function(e){
$([document.documentElement, document.body]).animate({ scrollTop: 0 }); 
 popupedit();
 $('body').addClass('editing editpopup');

   




     $(document).on("shopify:section:deselect",'#shopify-section-Popup',function(e){
        $('body').removeClass('editpopup');
        $( "#mailPopup" ).popup( "close");
     });   
}); 

  

  
function popupedit() {
     console.log('test5');
      $( "#mailPopup" ).popup( "open", {
       transition: "slideupfade",
        y: 100,
      }); 
}

var pp = 1;
function blowp() {
   bitchoutp();
    }

    (function yaya22p() {
        if (window.shop) {
            blowp();
        } else {
          if(pp < 30) {
            window.setTimeout(yaya22p, 50);
            pp++;
          }else{
           blowp();
          }
        }
    })();  


function bitchoutp() {
if(typeof window.shop !== "undefined" && window.shop == window.password) {
}else{
   function bitchp() {
  var o = 0;
 $('#mailPopup').remove();
}
bitchp(); 
 }
}     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Stories"]) return;
  try {
    
$(document).one("shopify:section:select",'#shopify-section-Stories',function(e){


var myElement = $('#shopify-section-Stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}    

$(document).one("shopify:section:deselect",'#shopify-section-Stories',function(e){                           
      
                           
$(document).one("shopify:section:select",'#shopify-section-Stories',function(e){
var myElement = $('#shopify-section-Stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('#swiper_Frame').animate({ scrollTop: topPos });  
}    
});                       
                           
                           
                           
});
});  
$(document).on("shopify:section:select",'#shopify-section-Stories',function(e){
story();
setTimeout(function() { 
scrollswiper(); 
},200);  
$('body').addClass('editing editstories');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editstories');
})
});  
var p = 1;
function blow() {
   bitchout();
    }

    (function yaya22() {
        if (window.shop) {
            blow();
        } else {
          if(p < 30) {
            window.setTimeout(yaya22, 50);
            p++;
          }else{
           blow();
          }
        }
    })();  


function bitchout() {
if(typeof window.shop !== "undefined" && window.shop == window.password) {
}else{
   function bitch() {
  var o = 0;
 $('.stories').remove();
}
bitch(); 
 }
}   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Yotpo"]) return;
  try {
     
var p = 1;
function blow() {
   bitchout();
    }

    (function yaya22() {
        if (window.shop) {
            blow();
        } else {
          if(p < 30) {
            window.setTimeout(yaya22, 50);
            p++;
          }else{
           blow();
          }
        }
    })();  


function bitchout() {
if(typeof window.shop !== "undefined" && window.shop == window.password) {
}else{
   function bitch() {
  var o = 0;
 $('.yotpo').remove();
}
bitch(); 
 }
}  


  } catch(e) { console.error(e); }
})();

})();
